import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['button', 'link', 'text'],
    base: {
        button: {
            size: 'lg'
        },
        link: {
            width: 'max-content'
        },
        text: {
            whiteSpace: 'normal',
            textAlign: 'center'
        }
    },
    variants: {
        variant: {
            primary: {
                button: {
                    variant: 'primaryFilled'
                }
            },
            secondary: {
                button: {
                    variant: 'secondaryOutline'
                }
            },
            text: {
                link: {
                    variant: 'secondary',
                    underline: true
                }
            },
            secondaryGhost: {
                button: {
                    variant: 'secondaryGhost'
                }
            }
        }
    }
})
